import { lazy } from 'react'

import { FormModeProvider } from '../../base/contexts/FormModeContext'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { TransferenciaInputProps, TransferenciaRecepcionInputProps } from './interfaces'
import {
  TransferenciaFormMode,
  transferenciaFormModeDefault,
  transferenciaFormModelConfig,
} from './services/transferenciaFormMode'
import {
  TransferenciaRecepcionFormMode,
  transferenciaRecepcionFormModeConfig,
  transferenciaRecepcionFormModeDefault,
} from './services/transferenciaRecepcionFormMode'

const TransferenciasSolicitudApp = lazy(() => import('./view/Transferencias'))
const TransferenciasRegistroRapido = lazy(() => import('./view/TransferenciasRegistroRapido'))
const TransferenciasGestionRapida = lazy(() => import('./view/TransferenciasGestionRapida'))
const TransferenciasRegistro = lazy(() => import('./view/TransferenciasRegistro'))
const TransferenciasActualizar = lazy(() => import('./view/TransferenciasActualizar'))
const TransferenciasGestionEnviar = lazy(() => import('./view/TransferenciasGestionEnviar'))
const TransferenciasEnviar = lazy(() => import('./view/TransferenciasEnviar'))
const TransferenciasGestionAprobar = lazy(() => import('./view/TransferenciasGestionAprobar'))
const TransferenciasAprobar = lazy(() => import('./view/TransferenciasAprobar'))
const TransferenciasGestionRecepcionar = lazy(() => import('./view/TransferenciasGestionRecepcionar'))
const TransferenciaRecepcionRegistro = lazy(() => import('./view/TransferenciaRecepcionRegistro'))
const TransferenciasGestionConsultar = lazy(() => import('./view/TransferenciasGestionConsultar'))
const TransferenciasConsultar = lazy(() => import('./view/TransferenciasConsultar'))
const RecepcionConsultar = lazy(() => import('./view/TransferenciaRecepcionConsulta'))

export const transferenciasRoutesMap = {
  gestion: {
    path: '/transferencias/upsert',
    name: 'Solicitar',
    action: 'SOLICITAR',
  },
  gestionRecepcionar: {
    path: '/transferencias/recepcionar',
    name: 'Recepcionar',
    action: 'ADMINISTRAR',
  },
  recepcionar: {
    path: '/transferencias/recepcionar/:id',
    name: 'Recepcionar Transferencias',
    action: 'ACEPTAR',
  },
  consultarRecepcionar: {
    path: '/transferencias/consultarRecepcionar/:id',
    name: 'Consultar Recepción',
    action: 'CONSULTAR ',
  },
  gestionEnviar: {
    path: '/transferencias/enviar',
    name: 'Enviar',
    action: 'ENVIAR',
  },
  enviar: {
    path: '/transferencias/enviar/:id',
    name: 'Enviar Transferencias',
    action: 'ADMINISTRAR',
  },
  gestionAprobar: {
    path: '/transferencias/aprobar',
    name: 'Aprobar',
    action: 'APROBAR',
  },
  aprobar: {
    path: '/transferencias/aprobar/:id',
    name: 'Aprobar Transferencias',
    action: 'ADMINISTRAR',
  },
  registro: {
    path: '/transferencias/nuevo',
    name: 'Registrar transferencia',
    action: 'ADMINISTRAR',
  },
  actualizar: {
    path: '/transferencias/actualizar/:id',
    name: 'Actualizar transferencia',
    action: 'ADMINISTRAR',
  },
  gestionConsultar: {
    path: '/transferencias/consultar',
    name: 'Consultar',
    action: 'CONSULTAR',
  },
  consultar: {
    path: '/transferencias/consultar/:id',
    name: 'Consulta detallada',
    action: 'CONSULTAR',
  },
  registroRapido: {
    path: '/transferencia/registroRapido',
    name: 'Registro Rápido',
    action: 'REGISTRO_RAPIDO',
  },
  gestionRapida: {
    path: '/transferencia/gestionRapida',
    name: 'Transferencias Rápidas',
    action: 'REGISTRO_RAPIDO',
  },
}

const transferenciasRoutes = [
  {
    path: transferenciasRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <TransferenciasSolicitudApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.registroRapido.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
          mode={'rapid'}
          config={transferenciaFormModelConfig}
          defaults={transferenciaFormModeDefault}
        >
          <TransferenciasRegistroRapido />
        </FormModeProvider>
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.gestionRapida.path,
    element: (
      <OperacionesProvider>
        <TransferenciasGestionRapida />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.registro.path,
    element: (
      <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
        mode={'create'}
        config={transferenciaFormModelConfig}
        defaults={transferenciaFormModeDefault}
      >
        <OperacionesProvider>
          <TransferenciasRegistro />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.actualizar.path,
    element: (
      <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
        mode={'edit'}
        config={transferenciaFormModelConfig}
        defaults={transferenciaFormModeDefault}
      >
        <OperacionesProvider>
          <TransferenciasActualizar />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.gestionAprobar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasGestionAprobar />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.aprobar.path,
    element: (
      <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
        mode={'consult'}
        config={transferenciaFormModelConfig}
        defaults={transferenciaFormModeDefault}
      >
        <OperacionesProvider>
          <TransferenciasAprobar />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.gestionEnviar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasGestionEnviar />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.enviar.path,
    element: (
      <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
        mode={'edit'}
        config={transferenciaFormModelConfig}
        defaults={transferenciaFormModeDefault}
      >
        <OperacionesProvider>
          <TransferenciasEnviar />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.gestionRecepcionar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasGestionRecepcionar />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.recepcionar.path,
    element: (
      <FormModeProvider<TransferenciaRecepcionInputProps, TransferenciaRecepcionFormMode>
        mode="create"
        config={transferenciaRecepcionFormModeConfig}
        defaults={transferenciaRecepcionFormModeDefault}
      >
        <OperacionesProvider>
          <TransferenciaRecepcionRegistro />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.consultarRecepcionar.path,
    element: (
      <FormModeProvider<TransferenciaRecepcionInputProps, TransferenciaRecepcionFormMode>
        mode="consult"
        config={transferenciaRecepcionFormModeConfig}
        defaults={transferenciaRecepcionFormModeDefault}
      >
        <OperacionesProvider>
          <RecepcionConsultar />
        </OperacionesProvider>
      </FormModeProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.gestionConsultar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasGestionConsultar />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <FormModeProvider<TransferenciaInputProps, TransferenciaFormMode>
          mode={'consult'}
          config={transferenciaFormModelConfig}
          defaults={transferenciaFormModeDefault}
        >
          <TransferenciasConsultar />
        </FormModeProvider>
      </OperacionesProvider>
    ),
  },
]

export default transferenciasRoutes
